<section>
  <a type="button" class="btn btn-back d-flex align-items-center py-5" [routerLink]="['/sales-activities']"
    routerLinkActive="router-link-active">
    <img src="assets/icons/arrow-left.png" alt=""> <span class="mx-4">Back</span>
  </a>


  <div class="container-fluid">

    <div class="container-card py-4 px-4">
      <div class="row g-3">
        <div class="col-12 col-md-12 col-lg-12">
          <h1 class="heading-1">Sales Type Performance</h1>
        </div>
      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="text-center">
                <span>Sales Type</span>
              </th>
              <th class="text-center">
                <span>Revenue</span>
              </th>
              <th class="text-center">
                <span>Handover</span>
              </th>
              <th class="text-center">
                <span>Won</span>
              </th>
              <th class="text-center">
                <span>Lost</span>
              </th>
              <th class="text-center">
                <span>Inquiry</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="isLoading">
              <tr>
                <td colspan="6" class="text-center">
                  <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!isLoading && ItemSalesType.length > 0">
              <tr *ngFor="let item of ItemSalesType">
                <td class="text-start none-underline">{{ item.sales_type }}</td>
                <td class="text-end">{{ item.revenue | rupiah }}</td>
                <td class="text-center">{{ item.handover }}</td>
                <td class="text-center">{{ item.won }}</td>
                <td class="text-center">{{ item.lost }}</td>
                <td class="text-center">{{ item.inquiry }}</td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!isLoading && ItemSalesType.length === 0">
              <tr>
                <td colspan="7" class="text-center">No sales type found</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button"
          *ngFor="let item of ItemSalesType; let i = index">
          <div class="card-header card-sm-header">
            <h5>{{ item.sales_type }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div class="card-sm-title mt-2">Revenue</div>
                <div class="card-sm-title mt-2">handover</div>
                <div class="card-sm-title mt-2">won</div>
                <div class="card-sm-title mt-2">lost</div>
                <div class="card-sm-title mt-2">inquiry</div>
              </div>
              <div class="col-7">
                <div class="card-sm-title mt-2">{{ item.revenue | rupiah }}</div>
                <div class="card-sm-title mt-2">{{ item.handover }}</div>
                <div class="card-sm-title mt-2">{{ item.won }}</div>
                <div class="card-sm-title mt-2">{{ item.lost }}</div>
                <div class="card-sm-title mt-2">{{ item.inquiry }}</div>
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="container-card py-4 px-4 my-4">
      <div class="row g-3">
        <div class="col-12 col-md-12 col-lg-6">
          <h1 class="heading-1">In House Sales Performance</h1>
        </div>
        <div class="col-12 col-md-12 col-lg-6">
          <div class="form-group group-input">
            <input type="text" class="form-control" placeholder="Search Sales Name" [(ngModel)]="searchTerm"
              (keyup)="onSearchSalesType($event)" [value]="searchTerm">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="text-center">
                <span>Sales Name</span>
              </th>
              <th class="text-center">
                <span>Revenue</span>
              </th>
              <th class="text-center">
                <span>Hand Over</span>
              </th>
              <th class="text-center">
                <span>Won</span>
              </th>
              <th class="text-center">
                <span>Lost</span>
              </th>
              <th class="text-center">
                <span>Inquiry</span>
              </th>
            </tr>

          </thead>
          <tbody>

            <ng-container *ngIf="isLoading">
              <tr>
                <td colspan="7" class="text-center">
                  <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!isLoading && ItemInHouseSales.length > 0">
              <tr *ngFor="let item of ItemInHouseSales">
                <td class="text-start" [routerLink]="['/sales-activities/sales-list/detail', item.id_sales]">{{ item.sales_name }}</td>
                <td class="text-end">{{ item.revenue | rupiah }}</td>
                <td class="text-center">{{ item.handover }}</td>
                <td class="text-center">{{ item.won }}</td>
                <td class="text-center">{{ item.lost }}</td>
                <td class="text-center">{{ item.inquiry }}</td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!isLoading && ItemInHouseSales.length === 0">
              <tr>
                <td colspan="7" class="text-center">No sales activities found</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button"
          *ngFor="let item of ItemInHouseSales; let i = index"
          [routerLink]="['/sales-activities/sales-list/detail', item.id_sales]">
          <div class="card-header card-sm-header">
            <h5>{{ item.sales_name }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div class="card-sm-title mt-2">Revenue</div>
                <div class="card-sm-title mt-2">Hand Over</div>
                <div class="card-sm-title mt-2">Won</div>
                <div class="card-sm-title mt-2">Lost</div>
                <div class="card-sm-title mt-2">Inquiry</div>
              </div>
              <div class="col-7">
                <div class="card-sm-title mt-2">{{ item.revenue | rupiah }}</div>
                <div class="card-sm-title mt-2">{{ item.handover | rupiah }}</div>
                <div class="card-sm-title mt-2">{{ item.won }}</div>
                <div class="card-sm-title mt-2">{{ item.lost }}</div>
                <div class="card-sm-title mt-2">{{ item.inquiry }}</div>
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start total-page-number">
          <h5 class="pageCount">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </h5>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPageSalesType()"
                  aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPageSalesType()"
                  aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChangeSalesType(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPagesSalesType">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPageSalesType()"
                  aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPagesSalesType">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPageSalesType()"
                  aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>



  </div>




</section>
